<template>
  <router-link tag="li" v-if="router && router.name && type==='item'" :to="router">
    <a href="#" :data-toggle="$root.device.isMobile?'push-menu':''" role="button">
      <i :class="icon"></i> <span>{{ $root.shortText(FullName, 20) }}</span>
      <span class="pull-right-container" v-show="badge">
        <small :class="['label pull-right', badge.type==='String'?'bg-green':'label-primary']">{{ badge.data }}</small>
      </span>
    </a>
  </router-link>
  <li :class="getType" v-else>
    <router-link tag="a" v-if="!isHeader" :to="router">
      <i :class="icon"></i> {{ $root.shortText(FullName, 20) }}
      <span class="pull-right-container">
        <small v-if="badge && badge.data >= 0" class="label pull-right label-primary">{{ badge.data }}</small>
        <i v-else class="fa fa-angle-left pull-right"></i>
      </span>
    </router-link>
    <ul class="treeview-menu" v-if="items && items.length > 0">
      <router-link tag="li" v-for="(item,index) in items" :title="item.FullName" v-show="item.show" :data="item" :key="index" :to="item.router" v-if="item.router && item.router.name && item['.key']!=='TotalDealers'">
        <a :data-toggle="$root.device.isMobile?'push-menu':''" role="button">
          <i :class="item.icon"></i> {{ $root.shortText(item.FullName, 20) }}
          <span class="pull-right-container">
            <small v-if="item.badge && item.badge.data >= 0" class="label pull-right bg-green">{{ item.badge.data }}</small>
          </span>
        </a>
        <ol class="subtreeview" :data-toggle="$root.device.isMobile?'push-menu':''" role="button" v-if="item.subItems && item.subItems.length > 0">
          <router-link tag="li" v-for="(subItem,subIndex) in item.subItems" :title="subItem.FullName" v-show="subItem.show" :data="subItem" :key="subIndex" :to="subItem.router">
            <a>{{ $root.shortText(subItem.FullName, 20) }}</a>
          </router-link>
        </ol>
      </router-link>
    </ul>
  </li>
</template>

<script>
  export default {
    name: 'va-slide-item',
    props: {
      type: {
        type: String,
        default: 'item'
      },
      isHeader: {
        type: Boolean,
        default: false
      },
      isLink: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: ''
      },
      FullName: {
        type: String
      },
      badge: {
        type: Object,
        default () {
          return {}
        }
      },
      items: {
        type: Array,
        default () {
          return []
        }
      },
      router: {
        type: Object,
        default () {
          return {
            name: ''
          }
        }
      },
      link: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    created () {

    },
    mounted () {

    },
    computed: {
      getType () {
        if (this.isHeader) {
          return 'header'
        } else if (this.type === 'item') {
          return ''
        } else if (this.isOpen) {
          return 'treeview menu-open'
        } else {
          return 'treeview'
        }
      }
    },
    methods: {
      openTree () {
        console.log('open ... close tree')
        this.isOpen = !this.isOpen
      }
    }
  }
</script>
<style>
  .subtreeview {
    background-color: #354349;
  }
    .subtreeview > li {
      list-style: decimal !important;
      padding: 0;
      margin: 0;
      color: #8aa4af;
    }
      .subtreeview > li > a {
        padding: 7px;
        display: block;
        font-size: 14px;
        color: #8aa4af;
      }
        .subtreeview > li > a:hover {
          color: #fff;
          background-color: #354349;
        }
        .subtreeview > li > a > .fa {
          width: 20px;
        }
</style>



// WEBPACK FOOTER //
// VASlideItem.vue?24fcbb28